import { CSSProperties, FC, PropsWithChildren } from 'react';

import Link from 'next/link';

import { TColorProp } from 'styled-components';

import { satoshi } from '~/common/styles/fonts';

import { Container, TTitleSize } from './styles';

interface ITitleProps extends PropsWithChildren {
  size: TTitleSize;
  color?: TColorProp;
  style?: CSSProperties;
  href?: string;
}

export const Title: FC<ITitleProps> = ({
  size,
  color = 'neutral.100',
  children,
  style,
  href,
}) => {
  const Element = (
    <Container
      $size={size}
      as={size}
      $color={color}
      className={satoshi.className}
      style={style}
    >
      {children}
    </Container>
  );

  return href ? (
    <Link href={href} passHref>
      {Element}
    </Link>
  ) : (
    Element
  );
};
